<template>
  <div>
    <CommonTitle titleText="学习情况"></CommonTitle>
    <div class="learning">
      <el-table
          :data="tableData"
          border
          :fit="true"
          style="width: 100%">
        <el-table-column
            prop="totalNum"
            label="总学时"
        >
        </el-table-column>
        <el-table-column
            prop="completeNum"
            label="已完成学时"
        >
        </el-table-column>
        <el-table-column
            label="是否完成">
          <template slot-scope="scope">
            <el-tag v-if="tagText" type="success">已完成</el-tag>
            <el-tag v-else type="danger">未完成</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "LearningSituation",
  data() {
    return {
      tableData: [],
      tagText: null
    }
  },
  created() {
    this.$get(this.$API.STATISTICS_STUDY_RECORD, {}).then(res => {
      this.tableData.push(res.data)
      this.tagText = res.data.totalNum === res.data.completeNum ? true : false
    })
  }
}
</script>

<style scoped lang="scss">
.learning {
  .right-desc {
    border-bottom: 1px solid #999999;
  }
}
</style>